import { render } from "./ViewDownloadsModal.vue?vue&type=template&id=6c03655f"
import script from "./ViewDownloadsModal.vue?vue&type=script&lang=js"
export * from "./ViewDownloadsModal.vue?vue&type=script&lang=js"

import "./ViewDownloadsModal.vue?vue&type=style&index=0&id=6c03655f&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__